#import "../fragments/behavior-fragment.graphql"
#import "../fragments/appearance-fragment.graphql"

query GetBehaviorSettings {
    chatSettings {
        ...BehaviorFragment
        ...AppearanceFragment
    }
}
